import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FormGroup } from '@angular/forms';

interface FilterInfo {
  filters?: {
    displayName?: string,
    value?: string
  }
  filterMatrix?: {
    row?: number,
    column?: number
  }
}

@Injectable({
  providedIn: 'root'
})

export class UserService {

  public subject = new Subject<string>();
  public cartSubject = new Subject<number>();
  public categoryViewSubject = new Subject<string>();
  public locationSubject = new BehaviorSubject<boolean>(false);
  public locationAddressSubject = new BehaviorSubject<boolean>(false);
  public flashMessageSubject = new Subject<boolean>();
  public showLoginButtonSubject = new Subject<boolean>();
  public adsActiveSubject = new BehaviorSubject<boolean>(true);
  public topBannerSubject = new BehaviorSubject<string>('#BlackLivesMatter') ;
  public loginURLSubject = new BehaviorSubject<string>('/login');
  public showFooterSubject = new BehaviorSubject<boolean>(true);
  public isRecipientPageSubject = new BehaviorSubject<boolean>(false);
  public clearSearchStringSubject = new BehaviorSubject<boolean>(false);
  public reloadOfferSubject = new BehaviorSubject<boolean>(false);
  public reloadCartDataSubject = new BehaviorSubject<boolean>(false);
  public setSlugNameSubject = new Subject<string>();
  public isLoginSignUpPageSubject = new BehaviorSubject<boolean>(false);
  public setCategoryView: string;
  public searchCriteria: string;
  public setFilterView: Array<FilterInfo>;
  public setSortView: number;
  public productListingState: boolean = false;
  public setCurrPageView: number;

  username$: Observable<string> = this.subject.asObservable();
  cartQty$: Observable<number> = this.cartSubject.asObservable();
  locationPresent$: Observable<boolean> = this.locationSubject.asObservable();
  changeLocationAddress$: Observable<boolean> = this.locationAddressSubject.asObservable();
  flashMessage$: Observable<boolean> = this.flashMessageSubject.asObservable();
  loginButton$: Observable<boolean> = this.showLoginButtonSubject.asObservable();
  adsActiveFlag: Observable<boolean> = this.adsActiveSubject.asObservable();
  loginSubject$: Observable<string> = this.loginURLSubject.asObservable();
  isLoginSignUpSubject$: Observable<boolean> = this.isLoginSignUpPageSubject.asObservable();
  footerSubject$: Observable<boolean> = this.showFooterSubject.asObservable();
  recipientPageSubject$: Observable<boolean> = this.isRecipientPageSubject.asObservable();
  clearSearchSubject$: Observable<boolean> = this.clearSearchStringSubject.asObservable();
  categoryViewString: Observable<string> = this.categoryViewSubject.asObservable();
  setSlugName$: Observable<string> = this.setSlugNameSubject.asObservable();
  reloadOffer$: Observable<boolean> = this.reloadOfferSubject.asObservable();
  reloadCartData$: Observable<boolean> = this.reloadCartDataSubject.asObservable();

  constructor() { }

  loadUsername(username: string): void {
    this.subject.next(username);
  }

  loadCartQty(qty: number): void {
    this.cartSubject.next(qty);
  }

  locationInfo(isLocation: boolean): void {
    this.locationSubject.next(isLocation);
  }

  locationAddress(change: boolean): void {
    this.locationAddressSubject.next(change);
  }

  flashMsg(change: boolean): void {
    this.flashMessageSubject.next(change);
  }

  showLoginButton(change:boolean): void {
    this.showLoginButtonSubject.next(change);
  }

  adsActive(isActive:boolean): void {
    this.adsActiveSubject.next(isActive);
  }

  topBannerChange(msg: string): void {
    this.topBannerSubject.next(msg);
  }

  loginURL(url: string): void {
    this.loginURLSubject.next(url);
  }

  footer(change:boolean): void {
    this.showFooterSubject.next(change);
  }

  recipientPageFunction(change:boolean): void {
    this.isRecipientPageSubject.next(change);
  }

  clearSearchText(change:boolean): void {
    this.clearSearchStringSubject.next(change);
  }

  changeCategoryView(change:string): void {
    this.categoryViewSubject.next(change);
  }

  getSlugName(name:string):void {
    this.setSlugNameSubject.next(name);
  }

  reloadOfferProduct(change: boolean):void {
    this.reloadOfferSubject.next(change);
  }

  reloadCartProductData(change: boolean):void {
    this.reloadCartDataSubject.next(change);
  }

  isLoginSignUp(change: boolean) : void {
    this.isLoginSignUpPageSubject.next(change)
  }

  /**
   * Check if Both password matches
   * @param password
   * @param confirmPassword
   */
  passwordMatch(mainPassword, confirmPassword) {
    return (formgroup: FormGroup) => {

      let password = formgroup.controls[mainPassword];
      let confirm_password = formgroup.controls[confirmPassword];
      const errors = confirmPassword.errors;

      if (password.value != confirm_password.value) {
        let newErrors = { notEquivalent: true};
        if (errors) {
          newErrors = Object.assign(errors, newErrors);
        }
        return confirm_password.setErrors(newErrors);
      } else {
        if (confirm_password.errors) {
          delete confirm_password.errors['notEquivalent'];
        }
        if (confirmPassword.errors && Object.keys[confirmPassword].length == 0) {
          confirm_password.setErrors(null);
        }
      }
    }
  }
}
